var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"before-close":_vm.handleBeforeClose,"width":"400px","custom-class":"user-batch-import-dialog","show-close":false}},[_c('div',[_c('div',{staticClass:"loading"},[_c('span',{staticClass:"el-icon-loading"}),_c('span',{staticClass:"text"},[_vm._v("批量导入授权中")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }